// extracted by mini-css-extract-plugin
export default {"statusCell":"wf01yHlqNlKVtrDQS4Ao"};